import { Component } from "react";
import ActionUtility from "../../utilities/ActionUtility";
import CustomTicketFieldEffect from "./CustomTicketFieldsEffect";

export class CustomTicketFieldsAction extends Component {
  //customfields requests
  static REQUEST_CUSTOMTICKETFIELDS =
    "CustomTicketFieldsAction.REQUEST_CUSTOMTICKETFIELDS";
  static REQUEST_CUSTOMTICKETFIELDS_FINISHED =
    "CustomTicketFieldsAction.REQUEST_CUSTOMTICKETFIELDS_FINISHED";

  //customfields list (for the Filter dropdown)
  static REQUEST_CUSTOMTICKETFIELDS_FILTER =
    "CustomTicketFieldsAction.REQUEST_CUSTOMTICKETFIELDS_FILTER";
  static REQUEST_CUSTOMTICKETFIELDS_FILTER_FINISHED =
    "CustomTicketFieldsAction.REQUEST_CUSTOMTICKETFIELDS_FILTER_FINISHED";

  //METHODS

  //customfields get method
  static requestCustomTicketFields(params) {
    return async (dispatch, getstate) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        CustomTicketFieldsAction.REQUEST_CUSTOMTICKETFIELDS,
        CustomTicketFieldEffect.requestCustomTicketFields,
        params
      );
    };
  }

  // filter
  static requestCustomTicketFieldsFilter(params) {
    return async (dispatch, getstate) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        CustomTicketFieldsAction.REQUEST_CUSTOMTICKETFIELDS_FILTER,
        CustomTicketFieldEffect.requestCustomTicketFieldsFilter,
        params
      );
    };
  }
}

export default CustomTicketFieldsAction;
